import { Box } from '@mui/system'
import React, { useEffect, useState } from 'react'
import { Legend, LoaderWrapper, ReportHeading, ReportOuterWrapper } from '../../../../components'
import { useGlobalStore } from '../../../../store'
import ComparisonTable from './comparisonTable'
import ProgressionRange from './progressionRange'
import DriversProgressionPopup from './driversProgressionPopup'
import { ContentWrap, RootWrap, GridHeaderWrapper, SegmentTableWrapper } from './style'
import { useComparisonData } from './useComparisonData'
import { usePopupDropdownArray } from './usePopupDropdownArray'
import SegmentTable from '../reportSegmentV2/segmentTable'
import ReportsService from '../../../../services/reports.service'
import { getProgressionArray, fakeDelay } from '../../../../util'
import Header from '../reportSegment/header'
import NewComponent from './newComponent'
import ReportSegmentV2 from '../reportSegmentV2'

const ComparisonViewDeepDiveNew = (props) => {
  const [progressionRangeObject, setProgressionRangeObject] = useState({})
  const { driverProgressionPopupObject, setDriverProgressionPopupObject } = useGlobalStore()
  // const [showTableGrid, setShowTableGrid] = useState('graph')

  // Use custom hooks
  const {
    state,
    segmentData,
    reportData,
    maxValue,
    segmentExcelData,
    periodInOrder,
    eventCount,
    setEventCount,
    progressionRangeArray,
    popupDropdownArray,
    keyOrdering,
    isLoading,
    isSuccess,
    isError,
    error,
    CONFIG,
  } = useComparisonData(props)

  const popupDropdownArrayWithAllMonths = usePopupDropdownArray(
    keyOrdering,
    popupDropdownArray,
    props.InsightsElementType
  )

  // Track expanded status
  const [expandedStatus, setExpandedStatus] = useState(false)
  const [activeTab2, setActiveTab2] = useState(0)
  const [reportDataNew, setReportDataNew] = useState()
  const [isNewComponent, setIsNewComponent] = useState('NEW_COMPONENT')

  const legendsData = [
    { label: 'Positive', value: 'Positive' },
    { label: 'Neutral', value: 'Neutral' },
    { label: 'Mixed', value: 'Mixed' },
    { label: 'Negative', value: 'Negative' },
  ]

  // Update expanded status from props
  useEffect(() => {
    if (props?.driversSegmentsExpanded) {
      setExpandedStatus(true)
    }
  }, [props?.driversSegmentsExpanded])

  // Update popup dropdown object in store
  useEffect(() => {
    if (popupDropdownArray?.length > 0) {
      setDriverProgressionPopupObject({
        ...driverProgressionPopupObject,
        popupDropdownArray: popupDropdownArray,
      })
    }
  }, [popupDropdownArray])

  useEffect(() => {
    setReportDataNew(reportData)
  }, [reportData])

  useEffect(() => {
    setReportDataNew(reportData)
  }, [])

  const AdditionalButtons = () => {
    return reportDataNew?.length > 0 ? (
      <ProgressionRange
        data={progressionRangeArray}
        progressionRangeObject={progressionRangeObject}
        setProgressionRangeObject={setProgressionRangeObject}
      />
    ) : null
  }

  const activeTab2_dataArray = async () => {
    if (activeTab2 === 1) {
      let idArray = [...reportDataNew].slice(0, progressionRangeObject.barsInGraph).filter(f => !f?.hasDataFromServer)?.map((item) => item.PeriodInsightsElementId) || []
      const totalLen = progressionRangeObject.barsInGraph

      const allResponses = await Promise.all(
        idArray.map(async (id) => {
          await fakeDelay(1000);

          return await ReportsService.reportGetDriverElementsApi({
            insightsElementId: id,
            entityId: props?.EntityId,
            type: ['SearchDriversProgression', 'SearchDriversProgression3Level'].includes(props.InsightsElementType) ? '__SearchDrivers' : null
          });
        })
      )

      const decodedResponsesObject = {}
      const decodedResponses = allResponses.map((resp, i) => {
        decodedResponsesObject['id_'+idArray[i]] = resp.respData
        return {['id_'+idArray[i]] : resp.respData}
      })

      const finalData = reportDataNew.map((d, i) => {
        if( decodedResponsesObject?.['id_'+d.PeriodInsightsElementId] && decodedResponsesObject['id_'+d.PeriodInsightsElementId]?.length > 0 ){
          d.PeriodDrivers.DriverElement = decodedResponsesObject['id_'+d.PeriodInsightsElementId]
          d.SegmentDrivers.DriverElement = decodedResponsesObject['id_'+d.PeriodInsightsElementId]
          d['hasDataFromServer'] = true
        }
        return d
      })

      setReportDataNew(finalData)
    }
  }

  useEffect(() => {
    activeTab2_dataArray()
  }, [activeTab2, progressionRangeObject])

  
  const strArr = [
    'jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec',
    'jan-feb', 'mar-apr', 'may-jun', 'jul-aug', 'sep-oct', 'nov-dec',
    'january', 'february', 'march', 'april', 'may', 'june', 'july', 'august',
    'september', 'october', 'november', 'december',
    'phase', 'phase1', 'phase2', 'phase3', 'phase4',
    't', 't1', 't2', 't3',
    'q', 'q1', 'q2', 'q3', 'q4',
    'h', 'h1', 'h2'
  ]
  const checkKeys = (arr) => {
    // expected arr = ['Metro', 'Tier1', 'Tier2', 'Tier3'] // in this case should return false
    // expected arr = ['B4', 'B6', 'B6(O)'] // in this case should return false
    // expected arr = ["Q2 2025","Q1 2025","Q4 2024","Q3 2024","Q2 2024","Q1 2024","Q4 2023","Q3 2023"] // in this case should return true
    // expected arr = ["Dec 25","Nov 25","Oct 25","Sep 25","Aug 25","Jul 25","Jun 25","May 25","Apr 25","Mar 25","Feb 25","Jan 25","Dec 24","Nov 24","Oct 24","Sep 24","Aug 24","Jul 24","Jun 24","May 24","Apr 24","Mar 24","Feb 24","Jan 24","Dec 23","Nov 23","Oct 23","Sep 23","Aug 23","Jul 23"] // in this case should return true


    const firstKeys = arr[0].toLowerCase().replace(/fy\d{2}/gi, '').replace(/\d+/g, "").replaceAll(' ','') // this is remove all the number
    const isMatch = strArr.includes(firstKeys)
    return isMatch
  }

  /*
  useEffect(() => {
    if( (keyOrdering?.length > 0 && checkKeys(keyOrdering)) ){
      setIsNewComponent('NEW_COMPONENT')
    } else {
      setTimeout(() => {
        if( (keyOrdering?.length > 0 && checkKeys(keyOrdering)) ){
          setIsNewComponent('NEW_COMPONENT')
        } else if( !((keyOrdering?.length > 0 && checkKeys(keyOrdering)) && isNewComponent === 'NEW_COMPONENT')) {
          setIsNewComponent('OLD_COMPONENT')
        }
      }, 10000)
    }
  }, [keyOrdering, popupDropdownArray, progressionRangeObject, isNewComponent])
  */

  useEffect(() => {
    setTimeout(() => {
      // if(!keyOrdering){
        console.log('check111111======progressionRangeObject===============', (keyOrdering?.length > 0 && checkKeys(keyOrdering)), keyOrdering)
      // }
      if( keyOrdering?.length > 0 && isNewComponent === 'NEW_COMPONENT') {
        if( !checkKeys(keyOrdering) ){
          console.log('check2222222======progressionRangeObject===============', keyOrdering)
          setIsNewComponent('OLD_COMPONENT')
        }
      }
    }, 10000)
  }, [keyOrdering, popupDropdownArray, progressionRangeObject, isNewComponent])

 
  return (
    <>
      {isNewComponent === 'NEW_COMPONENT' && <>
        {reportDataNew?.length > 0 && (
          <ReportHeading
            resetInsightHeight={eventCount}
            downloadId={props.type}
            {...props}
            // additionalButton={isNewComponent === 'NEW_COMPONENT' && <AdditionalButtons />}
            additionalButton={<AdditionalButtons />}
            downloadIdData={segmentExcelData}
            addTable={true}
            graphBtn={true}
          />
        )}
        
        <ReportOuterWrapper>
          <RootWrap
            id={props.type}
            className={`${props.InsightsElementType} ${
              props?.isPPTModalActive || props?.isProgressionActive ? 'exportToPPT' : ''
            }`}
          >
            <LoaderWrapper
              loadOnlyApi={props.loadOnlyApi}
              isLoading={isLoading}
              isSuccess={isSuccess}
              isError={isError}
              error={error}
            >
              <NewComponent
                activeTab2={activeTab2}
                setActiveTab2={setActiveTab2}
                segmentData={segmentData}
                eventCount={eventCount}
                progressionRangeObject={progressionRangeObject}
                props={props}
                keyOrdering={keyOrdering}
                maxValue={maxValue}
                state={state}
                CONFIG={CONFIG}
                expandedStatus={expandedStatus}
                setEventCount={setEventCount}
                periodInOrder={periodInOrder}
                progressionRangeArray={progressionRangeArray}
                popupDropdownArray={popupDropdownArray}
                popupDropdownArrayWithAllMonths={popupDropdownArrayWithAllMonths}
                driverProgressionPopupObject={driverProgressionPopupObject}
                reportDataNew={reportDataNew}
                legendsData={legendsData}
              />
            </LoaderWrapper>
          </RootWrap>
        </ReportOuterWrapper>          
      </>}
      {isNewComponent === 'OLD_COMPONENT' && <>
        <ReportSegmentV2 {...props}/>
      </>}
    </>
  )
}

export default ComparisonViewDeepDiveNew

